// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @media (max-width: 744px) {
    .page-title {
        display: none;
    }
} */
.menuSearch {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.page-title {
    font-weight: 600;

    @media(max-width: 450px){
        display: none;
    }
}


header {
    position: sticky;
    top: 0;
    z-index: 100;
}

.header_nav {
     background: #F8F8F8;
    padding: 1rem;
    height: 120px;
}
.header_search {
    position: relative;
    display: inline-block;
}

.header_search input{
    width: clamp(100px, 50vw, 370px);
    padding: 12px 12px 12px 40px;
    border-radius: 5px;
    box-sizing: border-box;
    border: 1px solid #9493936d;
    box-shadow: 0 2px 5px rgba(62, 62, 62, 0.151);
    border-radius: 43px;
}
.header_search input :focus-visible{
    border: none;
}

.header_search .search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #666;
    pointer-events: none;
}
.header_title{
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-content: flex-end;
}
.header-profile-area {
    position: relative;
    display: flex;
    align-items: center;
    margin-left: 16px;
}
.header-avatar-wrap {
    display: flex;
    align-items: center;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}
.header-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #004996;
    background: #e0e0e0;
}
.header-avatar-name {
    margin-left: 8px;
    font-weight: 500;
    color: #222;
    font-size: 1rem;
}
.header-profile-dropdown {
    position: absolute;
    right: 0;
    top: 54px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0,0,0,0.12);
    border-radius: 8px;
    min-width: 160px;
    z-index: 100;
    padding: 4px 0;
    display: flex;
    flex-direction: column;
}
.header-profile-dropdown-item {
    width: 100%;
    padding: 10px 16px;
    background: none;
    border: none;
    text-align: left;
    cursor: pointer;
    font-size: 1rem;
    color: #222;
    transition: background 0.2s;
}
.header-profile-dropdown-item:hover {
    background: #f5f5f5;
}
.header_title img{
    width: 30%;
}
.header_container {
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-content: space-between;
    margin-top: 20px;

    /* @media(max-width: 390px) {
        flex-direction: column;
        align-items: flex-start;
    } */
}
.header_container .menuSearch {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-left: 30px;
    @media(max-width: 768px) {
        gap: 0;
        margin: unset;
        margin-left: 0;
    }
}
.header_container .menubar {
    font-size: 2.2rem;
    color: #004996;
    cursor: pointer;
    padding: 0.5rem;
    transition: color 0.3s ease;
    display: block;
}

.header_container .menubar:hover {
    color: #012041;
}

/* Action dropdown styles */
.header_title {
    position: relative;
}

/* bell  */

.bell{
    color: #ffffff;
    cursor: pointer;
    padding: 0.7rem;
    transition: color 0.3s ease;
    margin-right: 20px;
    background: #004996;
    border-radius: 43px;
    width: 45px;
    height: 45px;
}
.bell:hover {
    animation: bell-shake 0.5s linear;
}

@keyframes bell-shake {
    0% { transform: rotate(0deg); }
    20% { transform: rotate(-25deg); }
    40% { transform: rotate(25deg); }
    60% { transform: rotate(-15deg); }
    80% { transform: rotate(15deg); }
    100% { transform: rotate(0deg); }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/header.css"],"names":[],"mappings":"AAAA;;;;GAIG;AACH;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;;IAEhB;QACI,aAAa;IACjB;AACJ;;;AAGA;IAEI,gBAAgB;IAChB,MAAM;IACN,YAAY;AAChB;;AAEA;KACK,mBAAmB;IACpB,aAAa;IACb,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;IAC5B,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,6CAA6C;IAC7C,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,WAAW;IACX,2BAA2B;AAC/B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,8BAA8B;IAC9B,gBAAgB;;IAEhB;;;OAGG;AACP;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB;QACI,MAAM;QACN,aAAa;QACb,cAAc;IAClB;AACJ;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,eAAe;IACf,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;AACtB;;AAEA,UAAU;;AAEV;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;AACA;IACI,iCAAiC;AACrC;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,MAAM,yBAAyB,EAAE;IACjC,MAAM,wBAAwB,EAAE;IAChC,MAAM,yBAAyB,EAAE;IACjC,MAAM,wBAAwB,EAAE;IAChC,OAAO,uBAAuB,EAAE;AACpC","sourcesContent":["/* @media (max-width: 744px) {\n    .page-title {\n        display: none;\n    }\n} */\n.menuSearch {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.page-title {\n    font-weight: 600;\n\n    @media(max-width: 450px){\n        display: none;\n    }\n}\n\n\nheader {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n    z-index: 100;\n}\n\n.header_nav {\n     background: #F8F8F8;\n    padding: 1rem;\n    height: 120px;\n}\n.header_search {\n    position: relative;\n    display: inline-block;\n}\n\n.header_search input{\n    width: clamp(100px, 50vw, 370px);\n    padding: 12px 12px 12px 40px;\n    border-radius: 5px;\n    box-sizing: border-box;\n    border: 1px solid #9493936d;\n    box-shadow: 0 2px 5px rgba(62, 62, 62, 0.151);\n    border-radius: 43px;\n}\n.header_search input :focus-visible{\n    border: none;\n}\n\n.header_search .search-icon {\n    position: absolute;\n    left: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #666;\n    pointer-events: none;\n}\n.header_title{\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    justify-content: flex-end;\n}\n.header-profile-area {\n    position: relative;\n    display: flex;\n    align-items: center;\n    margin-left: 16px;\n}\n.header-avatar-wrap {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    user-select: none;\n}\n.header-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 2px solid #004996;\n    background: #e0e0e0;\n}\n.header-avatar-name {\n    margin-left: 8px;\n    font-weight: 500;\n    color: #222;\n    font-size: 1rem;\n}\n.header-profile-dropdown {\n    position: absolute;\n    right: 0;\n    top: 54px;\n    background: #fff;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.12);\n    border-radius: 8px;\n    min-width: 160px;\n    z-index: 100;\n    padding: 4px 0;\n    display: flex;\n    flex-direction: column;\n}\n.header-profile-dropdown-item {\n    width: 100%;\n    padding: 10px 16px;\n    background: none;\n    border: none;\n    text-align: left;\n    cursor: pointer;\n    font-size: 1rem;\n    color: #222;\n    transition: background 0.2s;\n}\n.header-profile-dropdown-item:hover {\n    background: #f5f5f5;\n}\n.header_title img{\n    width: 30%;\n}\n.header_container {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    justify-content: space-between;\n    margin-top: 20px;\n\n    /* @media(max-width: 390px) {\n        flex-direction: column;\n        align-items: flex-start;\n    } */\n}\n.header_container .menuSearch {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    margin-left: 30px;\n    @media(max-width: 768px) {\n        gap: 0;\n        margin: unset;\n        margin-left: 0;\n    }\n}\n.header_container .menubar {\n    font-size: 2.2rem;\n    color: #004996;\n    cursor: pointer;\n    padding: 0.5rem;\n    transition: color 0.3s ease;\n    display: block;\n}\n\n.header_container .menubar:hover {\n    color: #012041;\n}\n\n/* Action dropdown styles */\n.header_title {\n    position: relative;\n}\n\n/* bell  */\n\n.bell{\n    color: #ffffff;\n    cursor: pointer;\n    padding: 0.7rem;\n    transition: color 0.3s ease;\n    margin-right: 20px;\n    background: #004996;\n    border-radius: 43px;\n    width: 45px;\n    height: 45px;\n}\n.bell:hover {\n    animation: bell-shake 0.5s linear;\n}\n\n@keyframes bell-shake {\n    0% { transform: rotate(0deg); }\n    20% { transform: rotate(-25deg); }\n    40% { transform: rotate(25deg); }\n    60% { transform: rotate(-15deg); }\n    80% { transform: rotate(15deg); }\n    100% { transform: rotate(0deg); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
